import CreatorDashboardShimmer from './CreatorDashboardShimmer';

export default CreatorDashboardShimmer;